var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showHint)?_c('v-alert',{staticClass:"validation-hint",attrs:{"border":"left","color":"red lighten-2","dark":""}},[_vm._v(" Some mandatory fields not filled / selected. Please review the form and try again. ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }